import { Component, OnInit, ElementRef, Input, PLATFORM_ID, Inject, NgZone, HostListener, Renderer2, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo, MediaStream } from 'angular-engine/modules/ng-express-engine/tokens';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
//import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

declare let chrome;
declare let cast;

@Component({
    selector: 'cast-widget',
    templateUrl: './cast-widget.template.html',
    styleUrls: ['./cast-widget.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CastWidget {
    @Input() isCasting: boolean = false;
    isClient: boolean = false;
    isChrome: boolean = false;
    afterRefresh: boolean = false;
    castSession: any;
    castContext: any;
    private state: boolean;
    private connectionAttempts = 10
    private message = "Cast Connected"

    constructor(
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        @Inject(APP_SETTINGS) private settings: Object,
        protected coreEffects: CoreEffects,
        private cd: ChangeDetectorRef
    ) {
        this.isClient = isPlatformBrowser(this.platformId);
        if (this.isClient) {
            this.isChrome = this.deviceInfo.userAgent.toLowerCase().indexOf("chrome") > -1;
        }
    }

    ngAfterViewInit() {
        if (this.isChrome) {
            this.getCastContext();
        }
    }

    private getCastContext() {
        try {
            this.castContext = cast.framework.CastContext.getInstance();
        }
        catch (oops) { }
        if (this.castContext) {
            this.castContext.addEventListener(cast.framework.CastContextEventType.SESSION_STATE_CHANGED, this.sessionStateChanged);
            this.initializeCastApi()
        }
        else if (this.connectionAttempts > 0) {
            this.connectionAttempts -= 1
            setTimeout(this.getCastContext.bind(this), 200);
            return;
        }
    }

    private getSession() {
        if (this.castContext) {
            this.castSession = this.castContext.getCurrentSession();
        }
        return this.castSession !== null
    }

    sessionStateChanged = (event) => {
        switch (event.sessionState) {
            case cast.framework.SessionState.SESSION_RESUMED:
            case cast.framework.SessionState.SESSION_STARTED:
                this.onInitSuccess()               
                break
            case cast.framework.SessionState.SESSION_ENDING:
                this.cleanCastSession()
                break;
            case cast.framework.SessionState.SESSION_ENDED:
                this.toggleActive(false)
                this.togglePlaying(false)
                break;
            case cast.framework.SessionState.SESSION_START_FAILED:
                break;
        }
    }

    private exitChromecastMode() {
        if (!this.castSession) {
            return;
        }
        this.castSession.endSession(true);
    }

    toggleActive(active) {
        this.state = active;
        this.isCasting = active;
        this.cd.detectChanges();
    }

    togglePlaying(isPlaying) {
        //set proper widget messaging
        var  deviceName =  "";
        if (this.castSession) {        
            const device = this.castSession.getCastDevice()
            deviceName = device ? device.friendlyName : "Chromecast";
        }
        this.message = (isPlaying ? "Playing on " : "Connected to ") + deviceName
        this.cd.detectChanges();
        
    }

    public initializeCastApi() {
        //console.log(chrome);
        if (typeof chrome != 'undefined' && (!chrome.cast || !chrome.cast.isAvailable)) {
            setTimeout(this.initializeCastApi.bind(this), 500);
            return;
        }

        let options = {};
        var apiConfig, appId, sessionRequest;
        appId = this.settings['CHROMECAST_RECEIVER_ID'];

        cast.framework.CastContext.getInstance().setOptions({
            receiverApplicationId: appId,
            autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED
        });

        this.onInitSuccess()
    }

    private onInitSuccess() {
        if (this.getSession()) {
            this.toggleActive(true);
            this.addPlaybackListeners();
        }
    }

    private addPlaybackListeners() {
        let media = this.castSession.getMediaSession();
        if (media) {
            this.onMediaStatusUpdate(null)
        }

        this.castSession.addEventListener(cast.framework.SessionEventType.MEDIA_SESSION, this.attachMediaListeners)
    }

    attachMediaListeners = (e) => {
        let media = this.castSession.getMediaSession();
        if (media && !media.vgReady) {
            media.addUpdateListener(this.onMediaStatusUpdate);
            media["vgReady"] = true
        }
    }

    onMediaStatusUpdate = (e) => {
        let media = this.castSession.getMediaSession();
        let playerState = chrome.cast.media.PlayerState;
        if (media && (media.playerState == playerState.PLAYING || media.playerState == playerState.PAUSED)) {
            this.togglePlaying(true);
        }
        else {
            this.togglePlaying(false);
        }
    }

    ngOnDestroy() {
        if (this.castContext) {
            this.cleanCastSession()
            this.castContext.removeEventListener(cast.framework.CastContextEventType.SESSION_STATE_CHANGED, this.sessionStateChanged);
            this.castContext = null
        }
    }

    cleanCastSession() {
        if (this.castSession) {
            this.castSession.removeEventListener(cast.framework.SessionEventType.MEDIA_SESSION, this.attachMediaListeners)
            let media = this.castSession.getMediaSession();
            if (media) {
                media.removeUpdateListener(this.onMediaStatusUpdate)
            }
            this.castSession = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/chromcast-widget/cast-widget.component.ts